function activateAoiVideo(player) {
  const id = player?.dataset.aoiYoutubeId;
  if (!id || player.querySelector('iframe')) return;
  const iframe = document.createElement('iframe');
  const muted = player.dataset.aoiAutoplay === 'true';
  iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&mute=${muted ? '1' : '0'}&playsinline=1&rel=0`;
  iframe.title = player.querySelector('button')?.getAttribute('aria-label')?.replace(/^Play\s+/i, '') || 'AOI.CYCLE video';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  player.replaceChildren(iframe);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.aoi-click-video__poster');
  if (trigger) activateAoiVideo(trigger.closest('.aoi-click-video'));
});

function autoplayAoiVideos(scope = document) {
  scope.querySelectorAll('.aoi-click-video[data-aoi-autoplay="true"]').forEach(activateAoiVideo);
}

function formatAoiCarpentryStory() {
  if (!location.pathname.endsWith('/aoi-cycle-x-national-taiwan-craft-research-and-development-institute-the-journey-to-carpentry')) return;
  const root = document.querySelector('#MainContent .blog-post-content rte-formatter');
  if (!root || root.dataset.aoiFormatted === 'true') return;
  root.dataset.aoiFormatted = 'true';
  root.classList.add('aoi-carpentry-story');
  const blocks = root.innerHTML.trim().split(/\n\s*\n+/).map((block) => block.trim()).filter(Boolean);
  const output = document.createDocumentFragment();
  blocks.forEach((block) => {
    if (/^https?:\/\/(?:www\.)?youtube\.com\/watch\?v=Be3BfrPSKVA/i.test(block)) return;
    const container = document.createElement('div');
    container.innerHTML = block;
    const heading = container.querySelector(':scope > h2:first-child');
    if (heading) {
      output.append(heading);
      const remainder = container.innerHTML.trim();
      if (remainder) { const meta = document.createElement('p'); meta.className = 'aoi-story-date'; meta.innerHTML = remainder; output.append(meta); }
    } else {
      const paragraph = document.createElement('p');
      paragraph.innerHTML = block;
      output.append(paragraph);
    }
  });
  root.replaceChildren(output);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { formatAoiCarpentryStory(); autoplayAoiVideos(); });
else { formatAoiCarpentryStory(); autoplayAoiVideos(); }
document.addEventListener('shopify:section:load', (event) => { formatAoiCarpentryStory(); autoplayAoiVideos(event.target); });
